import React from "react";
import { LogoWrapper, StyledLogo } from "./logostyle";
import logo from "./Shenzu Spending.png";

const Logo = () => {
  return (
    <LogoWrapper>
      <StyledLogo src={logo} />
    </LogoWrapper>
  );
};

export default Logo;
